import React, { useEffect } from 'react';

interface NonInteractiveAutoRefreshProps {
  onRefresh?: () => void;
}

export const NonInteractiveAutoRefresh: React.FC<
  NonInteractiveAutoRefreshProps
> = ({ onRefresh }) => {
  const selectedIntervalInSeconds = 180;

  useEffect(() => {
    if (!selectedIntervalInSeconds) {
      return;
    }
    const interval = setInterval(() => {
      if (onRefresh) {
        onRefresh();
      }
    }, selectedIntervalInSeconds * 1000);

    return () => clearInterval(interval);
  }, [onRefresh, selectedIntervalInSeconds]);

  return null;
};
